import React from 'react'

const Cis1 = () => {
    return (
        <div className='container'>
        <h1>Find the Missing Number</h1>
        <p>You are given a list of n-1 integers and these integers are in the range of 1 to n. There are no duplicates in the list. One of the integers is missing in the list. Write an efficient code to find the missing integer.<br/>
        <strong>Example:</strong>&nbsp;</p>
        <pre><strong>Input:</strong> arr[] ={` {1, 2, 4, 6, 3, 7, 8}`} <br />
<strong>Output:</strong> 5 <br />
<strong>Explanation:</strong> The missing number from 1 to 8 is 5 <br />
<br />
<strong>Input:</strong> arr[] ={` {1, 2, 3, 5}`} <br />
<strong>Output:</strong> 4 <br />
<strong>Explanation:</strong> The missing number from 1 to 5 is 4</pre>
<p><br/><strong><u>Solution</u>:</strong> This method uses the technique of XOR to solve the problem.&nbsp;&nbsp;</p>
<ul><li><strong>Approach:</strong>&nbsp;<br/>
<i>XOR has certain properties&nbsp;</i><ul><li>Assume a1 ^ a2 ^ a3 ^ …^ an = a and a1 ^ a2 ^ a3 ^ …^ an-1 = b</li>
<li>Then a ^ b = an</li>
</ul></li>
<li><strong>Algorithm:</strong>&nbsp;<ol><li>Create two variables <i>a = 0</i> and <i>b = 0</i></li>
<li>Run a loop from 1 to n with i as counter.</li>
<li>For every index update <i>a</i> as <i>a = a ^ i</i></li>
<li>Now traverse the array from start to end.</li>
<li>For every index update <i>b</i> as <i>b = b ^ array[i]</i></li>
<li>Print the missing number as <i>a ^ b</i>.</li>
</ol></li>

<li><strong>Implementation:</strong></li>
</ul>
               <div class="tabs">
<input type="radio" name="tab" id="tab1"/>
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">C</label>

<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
<div class="line number2 index1 alt1"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="comments">// Function to get the missing number</code></div>
<div class="line number5 index4 alt2"><code class="color1 bold">int</code> <code
        class="plain">getMissingNo(</code><code class="color1 bold">int</code> <code class="plain">a[], </code><code
        class="color1 bold">int</code> <code class="plain">n)</code></div>
<div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// For xor of all the elements in array</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x1 = a[0];</code></div>
<div class="line number9 index8 alt2">&nbsp;</div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// For xor of all the elements from 1 to n+1</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x2 = 1;</code></div>
<div class="line number12 index11 alt1">&nbsp;</div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
        class="plain">i = 1; i &lt; n; i++)</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x1 = x1 ^ a[i];</code></div>
<div class="line number15 index14 alt2">&nbsp;</div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
        class="plain">i = 2; i &lt;= n + 1; i++)</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x2 = x2 ^ i;</code></div>
<div class="line number18 index17 alt1">&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(x1 ^ x2);</code></div>
<div class="line number20 index19 alt1"><code class="plain">&#125;</code></div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code class="comments">// Driver Code</code></div>
<div class="line number23 index22 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number24 index23 alt1"><code class="plain">&#123;</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">arr[] = &#123; 1, 2, 4, 5, 6 &#125;;</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">n = </code><code class="keyword bold">sizeof</code><code
        class="plain">(arr) / </code><code class="keyword bold">sizeof</code><code class="plain">(arr[0]);</code>
</div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">miss = getMissingNo(arr, n);</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; miss;</code></div>
<div class="line number29 index28 alt2"><code class="plain">&#125;</code></div>
</div>
  </div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Java program to find missing Number</code></div>
<div class="line number2 index1 alt1"><code class="comments">// using xor</code></div>
<div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">Main &#123;</code></div>
<div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Function to find missing number</code></div>
<div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">int</code> <code class="plain">getMissingNo(</code><code
        class="keyword">int</code> <code class="plain">a[], </code><code class="keyword">int</code> <code
        class="plain">n)</code></div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number7 index6 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">x1 = a[</code><code class="value">0</code><code
        class="plain">];</code></div>
<div class="line number8 index7 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">x2 = </code><code class="value">1</code><code
        class="plain">;</code></div>
<div class="line number9 index8 alt2">&nbsp;</div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* For xor of all the elements</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">in array */</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
        class="plain">i = </code><code class="value">1</code><code class="plain">; i &lt; n; i++)</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x1 = x1 ^ a[i];</code></div>
<div class="line number14 index13 alt1">&nbsp;</div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* For xor of all the elements</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">from 1 to n+1 */</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
        class="plain">i = </code><code class="value">2</code><code class="plain">; i &lt;= n + </code><code
        class="value">1</code><code class="plain">; i++)</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x2 = x2 ^ i;</code></div>
<div class="line number19 index18 alt2">&nbsp;</div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">(x1 ^ x2);</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number22 index21 alt1">&nbsp;</div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* program to test above function */</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main(String args[])</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">a[] = &#123; </code><code class="value">1</code><code
        class="plain">, </code><code class="value">2</code><code class="plain">, </code><code
        class="value">4</code><code class="plain">, </code><code class="value">5</code><code
        class="plain">, </code><code class="value">6</code> <code class="plain">&#125;;</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">miss = getMissingNo(a, </code><code
        class="value">5</code><code class="plain">);</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(miss);</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number30 index29 alt1"><code class="plain">&#125;</code></div>
</div>
    </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Python3 program to find</code></div>
<div class="line number2 index1 alt1"><code class="comments"># the mising Number</code></div>
<div class="line number3 index2 alt2"><code class="comments"># getMissingNo takes list as argument</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="keyword">def</code> <code
        class="plain">getMissingNo(a, n):</code></div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x1 </code><code class="keyword">=</code> <code class="plain">a[</code><code
        class="value">0</code><code class="plain">]</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x2 </code><code class="keyword">=</code> <code class="value">1</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
        class="functions">range</code><code class="plain">(</code><code class="value">1</code><code
        class="plain">, n):</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x1 </code><code class="keyword">=</code> <code class="plain">x1 ^ a[i]</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
        class="functions">range</code><code class="plain">(</code><code class="value">2</code><code
        class="plain">, n </code><code class="keyword">+</code> <code class="value">2</code><code
        class="plain">):</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x2 </code><code class="keyword">=</code> <code class="plain">x2 ^ i</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">x1 ^ x2</code></div>
<div class="line number16 index15 alt1">&nbsp;</div>
<div class="line number17 index16 alt2">&nbsp;</div>
<div class="line number18 index17 alt1"><code class="comments"># Driver program to test above function</code></div>
<div class="line number19 index18 alt2"><code class="keyword">if</code> <code class="plain">__name__</code><code
        class="keyword">=</code><code class="keyword">=</code><code class="string">'__main__'</code><code
        class="plain">:</code></div>
<div class="line number20 index19 alt1">&nbsp;</div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a </code><code class="keyword">=</code> <code class="plain">[</code><code
        class="value">1</code><code class="plain">, </code><code class="value">2</code><code
        class="plain">, </code><code class="value">4</code><code class="plain">, </code><code
        class="value">5</code><code class="plain">, </code><code class="value">6</code><code class="plain">]</code>
</div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">n </code><code class="keyword">=</code> <code class="functions">len</code><code
        class="plain">(a)</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">miss </code><code class="keyword">=</code> <code class="plain">getMissingNo(a, n)</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code><code class="plain">(miss)</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number26 index25 alt1"><code class="comments"># This code is contributed by Yatin Gupta</code>
</div>
</div>
    </div>
 
   
  <div id="tab-content-4" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
<div class="line number2 index1 alt1">&nbsp;</div>
<div class="line number3 index2 alt2"><code
        class="comments">/* getMissingNo takes array and size of array as arguments*/</code></div>
<div class="line number4 index3 alt1"><code class="color1 bold">int</code> <code
        class="plain">getMissingNo(</code><code class="color1 bold">int</code> <code class="plain">a[], </code><code
        class="color1 bold">int</code> <code class="plain">n)</code></div>
<div class="line number5 index4 alt2"><code class="plain">&#123;</code></div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">i;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x1 = a[0]; </code><code
        class="comments">/* For xor of all the elements in array */</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x2 = 1; </code><code
        class="comments">/* For xor of all the elements from 1 to n+1 */</code></div>
<div class="line number9 index8 alt2">&nbsp;</div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">for</code> <code class="plain">(i = 1; i &lt; n; i++)</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x1 = x1 ^ a[i];</code></div>
<div class="line number12 index11 alt1">&nbsp;</div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">for</code> <code class="plain">(i = 2; i &lt;= n + 1; i++)</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x2 = x2 ^ i;</code></div>
<div class="line number15 index14 alt2">&nbsp;</div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(x1 ^ x2);</code></div>
<div class="line number17 index16 alt2"><code class="plain">&#125;</code></div>
<div class="line number18 index17 alt1">&nbsp;</div>
<div class="line number19 index18 alt2"><code class="comments">/*program to test above function */</code></div>
<div class="line number20 index19 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number21 index20 alt2"><code class="plain">&#123;</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">a[] = &#123; 1, 2, 4, 5, 6 &#125;;</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">miss = getMissingNo(a, 5);</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d"</code><code
        class="plain">, miss);</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">getchar</code><code class="plain">();</code></div>
<div class="line number26 index25 alt1"><code class="plain">&#125;</code></div>
</div>
    </div>
    </div>
</div>
    </div>
    )
}

export default Cis1
